import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-add-book-credit-price1',
  templateUrl: './add-book-credit-price1.component.html',
  styleUrl: './add-book-credit-price1.component.scss'
})
export class AddBookCreditPrice1Component {
  bookreceipt: any;
  bookdata: any[] = [];
  updatedBooks: any[] = [];

  total_credit_amt: number = 0;
  totalAmount1Sum: number = 0;
  shippingChargesSum: number = 0;
  crdtvAmt = 0;
  selectedAmt = 0;
  selectedCopies = 0;
  balanceAmt = 0;
  bal = 0;
  totalReturnCopies: number = 0;
  totalCreditAmount: number = 0;
  totalRemainingAmount: number = 0;

  remarkOptions: string[] = [
    'विक्री झाली नाही',
    'खराब पुस्तके परत आली',
    'बुक सेलर पैसे भरत नाही',
    'TDS रक्कम'
  ];

  constructor(
    public service: DigisubservicesService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddBookCreditPrice1Component>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.bookreceipt = this.data['book'];
    this.crdtvAmt = isNaN(this.data['crdtAmt']) ? 0 : this.data['crdtAmt'];
    this.selectedAmt = isNaN(this.data['seAmt']) ? 0 : this.data['seAmt'];
    this.balanceAmt = isNaN(this.data['balAmt']) ? 0 : this.data['balAmt'];
    this.bal = isNaN(this.data['bal']) ? 0 : this.data['bal'];
    this.selectedCopies = isNaN(this.data['seCopies']) ? 0 : this.data['seCopies'];

    this.service.getCrdtWiseBooks1(this.bookreceipt['crdtnote_no']).subscribe((data: any[]) => {
      this.bookdata = data.map((book) => {
        const total_amount = this.toNum(book['total']) + this.toNum(book['shipping_charges']);
        const received = this.toNum(book['received_amt']);
        const remaining_amt = total_amount - received;
        const creditRemark = book['credit_remark'] || '';

        // ✅ Ensure API remark is in options list dynamically
        if (creditRemark && !this.remarkOptions.includes(creditRemark)) {
          this.remarkOptions.push(creditRemark);
        }

        return {
          id: this.bookreceipt['id'],
          book_name: book['book_name'],
          book_id: book['book_id'],           // ✅ use book_id consistently
          book_price: this.toNum(book['book_price']),
          book_copies: this.toInt(book['book_copies']),
          total: this.toNum(book['total']),
          shipping_charges: this.toNum(book['shipping_charges']),
          rep_name: book['rep_name'],
          office_rep_name: book['office_rep_name'],
          return_copies: this.toInt(book['return_copies']),
          crdtnote_amt: this.toNum(book['crdtnote_amt']),
          credit_remark: creditRemark,
          credit_amount: this.toInt(book['return_copies']) > 0
            ? this.round2(this.toNum(book['book_price']) * this.toInt(book['return_copies']))
            : this.toNum(book['crdtnote_amt']),
          remark: creditRemark,               // ✅ bind remark from API credit_remark
          total_amount: total_amount,
          received_amt: received,
          remaining_amt: remaining_amt,
          manualOverride: false,
          invoice_no: this.bookreceipt['invoice_no'],
          isDisabled: remaining_amt === 0,
          order_no: book['order_no']
        };
      });

      this.totalRemainingAmount = this.round2(
        this.bookdata.reduce((sum, b) => sum + (b.remaining_amt || 0), 0)
      );

      this.recalculateTotals(true);
    });
  }

  private toInt(v: any): number {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 0;
  }

  private toNum(v: any): number {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  }

  private round2(n: number): number {
    return Math.round((n + Number.EPSILON) * 100) / 100;
  }

  private addOrUpdateUpdatedBook(book: any) {
    const idx = this.updatedBooks.findIndex(b => b.book_id === book.book_id); // ✅ book_id
    const updatedBook = {
      book_id: book.book_id,
      crdtnote_amt: book.crdtnote_amt || 0,
      credit_remark: book.remark || book.credit_remark || '',
      return_copies: book.return_copies || 0,
      shipping_charges: book.shipping_charges || 0
    };
    if (idx !== -1) this.updatedBooks[idx] = updatedBook;
    else this.updatedBooks.push(updatedBook);
  }

  calculateCopies(event: any, book: any) {
    let val = parseInt(event?.target?.value, 10) || 0;

    if (val > this.toInt(book.book_copies)) {
      val = this.toInt(book.book_copies);
      alert(`Return copies cannot exceed available copies (${book.book_copies})`);
    }

    book.return_copies = val;

    if (!book.manualOverride) {
      book.crdtnote_amt = this.round2(this.toNum(book.book_price) * val); // ✅ update crdtnote_amt
      book.credit_amount = book.crdtnote_amt;
    }

    this.addOrUpdateUpdatedBook(book);
    this.recalculateTotals();
  }

  onCreditAmountInput(val: any, book: any) {
    const creditAmount = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
    book.crdtnote_amt = creditAmount;       // ✅ correct field
    book.credit_amount = creditAmount;
    book.manualOverride = true;

    this.addOrUpdateUpdatedBook(book);
    this.recalculateTotals();
  }

  onShippingChargesInput(val: any, book: any) {
    book.shipping_charges = parseFloat(val) || 0;
    this.addOrUpdateUpdatedBook(book);
    this.recalculateTotals();
  }

  onRemarkChange(value: string, book: any) {
    book.remark = value;
    book.credit_remark = value;
    this.addOrUpdateUpdatedBook(book);
  }

  calculateTotalAmount1(book: any): number {
    const credit = this.toNum(book.crdtnote_amt);
    const shipping = this.toNum(book.shipping_charges);
    return this.round2(credit + shipping);
  }

  recalculateTotals(isInitial: boolean = false) {
    if (!this.bookdata || this.bookdata.length === 0) {
      this.totalReturnCopies = 0;
      this.totalCreditAmount = 0;
      this.shippingChargesSum = 0;
      this.totalAmount1Sum = 0;
      this.selectedAmt = 0;
      this.balanceAmt = Number(this.crdtvAmt) || 0;
      return;
    }

    this.totalReturnCopies = this.bookdata.reduce(
      (sum, b) => sum + this.toInt(b.return_copies), 0
    );

    this.totalCreditAmount = this.round2(
      this.bookdata.reduce((sum, b) => sum + this.toNum(b.crdtnote_amt), 0)
    );

    this.shippingChargesSum = this.round2(
      this.bookdata.reduce((sum, b) => sum + this.toNum(b.shipping_charges), 0)
    );

    this.totalAmount1Sum = this.round2(
      this.bookdata.reduce(
        (sum, b) => sum + this.toNum(b.crdtnote_amt) + this.toNum(b.shipping_charges), 0
      )
    );

    this.selectedAmt = this.round2(this.totalAmount1Sum);
    this.balanceAmt = this.round2((Number(this.crdtvAmt) || 0) - this.selectedAmt);
  }

  // update() {
  //   if (!this.updatedBooks || this.updatedBooks.length === 0) {
  //     alert('No changes to update.');
  //     return;
  //   }

  //   const payload = {
  //     id: this.bookreceipt.id,
  //     book: this.updatedBooks.map(book => ({
  //       book_id: book.book_id,
  //       crdtnote_amt: book.crdtnote_amt || 0,
  //       credit_remark: book.credit_remark || '',
  //       return_copies: book.return_copies || 0,
  //       shipping_charges: book.shipping_charges || 0
  //     }))
  //   };

  //   console.log('Payload:', payload);

  //   this.service.updateBookCreditNoteBook(payload).subscribe({
  //     next: response => {
  //       console.log('Books updated:', response);
  //       alert('Books updated successfully!');
  //       this.dialogRef.close({ updated: true });
  //     },
  //     error: err => {
  //       console.error('Error updating books:', err);
  //       alert('Failed to update books.');
  //     }
  //   });
  // }
}